import { Component, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { EntityService } from '../../entity.service';

@Component({
  selector: 'app-add-contact',
  templateUrl: './add-contact.component.html',
  styleUrls: ['./add-contact.component.scss']
})
export class AddContactComponent implements OnInit {
  @ViewChild('deleteCntctCnfrmDialog') deleteCntctCnfrmDialog: TemplateRef<any>;
  constructor(public matDialogRef: MatDialogRef<AddContactComponent>, private fb: FormBuilder, public _contactService: EntityService, @Inject(MAT_DIALOG_DATA) public dialogData: any, private _matDialog: MatDialog) { }
  contactForm: FormGroup;
  ctgryLst = []
  cntctTypsLst = []
  hndlr_nm
  enty_ky
  editData
  hdng_nm
  sve_btn
  deleteDialog
  loader
  ngOnInit(): void {
    this.contactForm = this.fb.group({
      "cntct_type_id": new FormControl('', Validators.required),
      "cntct_nm": new FormControl('', Validators.required),
      "mble_ph": new FormControl(''),
      "mble2_ph": new FormControl(''),
      "eml_tx": new FormControl(''),
      "dsgnt_nm": new FormControl('', Validators.required),
    });
    if (this.dialogData) {
      if (this.dialogData.edit_in) {
        this.hndlr_nm = this.dialogData.hndlr_nm;
        this.enty_ky = this.dialogData.enty_ky;
        this.editData = this.dialogData.editData;
        this.hdng_nm = 'Edit';
        this.sve_btn = 'Update';
        this.getCntctTyps();
      }
      else {
        this.hndlr_nm = this.dialogData.hndlr_nm;
        this.enty_ky = this.dialogData.enty_ky;
        this.hdng_nm = 'Add';
        this.sve_btn = 'Add';
        this.getCntctTyps();
      }
    }
    else {
      this.hndlr_nm = 'contacts';
      this.enty_ky = 1;
      this.hdng_nm = 'Add';
      this.sve_btn = 'Add';
      this.getCntctTyps();
    }


  }
  Close(): void {
    this.matDialogRef.close();
  }
  send() {
    if(this.editData)
    {
      this.loader=true
      this.contactForm.value['cntct_id'] = this.editData.cntct_id
      this.contactForm.value['enty_ky'] = this.enty_ky
      this.contactForm.value['hndlr_nm'] = this.hndlr_nm
      this._contactService.updte_contact(this.contactForm.value).subscribe((res) => {
        if (res['status'] == 200) {
          this.loader=false
          this._contactService.openSnackBar("Contact Added Successfully", 'mat-primary');
          this.matDialogRef.close();
        }
        else {
          this._contactService.openSnackBar(res['message'], 'mat-warn');
        }
  
      })
    }
    else
    {
      this.loader=true
      this.contactForm.value['enty_ky'] = this.enty_ky
      this.contactForm.value['hndlr_nm'] = this.hndlr_nm
      this._contactService.new_contact(this.contactForm.value).subscribe((res) => {
        this.loader=false
        if (res['status'] == 200) {
          this._contactService.openSnackBar("Contact Added Successfully", 'mat-primary');
          this.matDialogRef.close();
        }
        else {
          this._contactService.openSnackBar(res['message'], 'mat-warn');
        }
  
      })
    }
    

  }
  getCntctTyps() {
    this._contactService.get_contacts_types(this.hndlr_nm).subscribe((res) => {
      if (res['status'] == 200) {
        this.cntctTypsLst = res['data']
        if(this.cntctTypsLst.length==1)
        {
          this.contactForm.get('cntct_type_id').setValue(this.cntctTypsLst[0].cntct_type_id)
        }
        if (this.editData) 
        {
          this.editFnc()
        }
      }
      else {
        this._contactService.openSnackBar(res['message'], 'amber');
      }
    })
  }
  editFnc() {
    this.contactForm.get('cntct_type_id').setValue(this.editData.cntct_type_id)
    this.contactForm.get('cntct_nm').setValue(this.editData.cntct_nm)
    this.contactForm.get('dsgnt_nm').setValue(this.editData.dsgnt_nm)
    this.contactForm.get('eml_tx').setValue(this.editData.eml_tx)
    this.contactForm.get('mble_ph').setValue(this.editData.mble_ph)
    this.contactForm.get('mble2_ph').setValue(this.editData.mble2_ph)
  }

  delete() {
    this.deleteDialog = this._matDialog.open(this.deleteCntctCnfrmDialog);
  }
  deleteCntct() {
    this.deleteDialog.close()
    this.loader = true;
    this._contactService.remove_contact(this.editData.cntct_id).subscribe((res) => {
      this.loader = false
      if (res['status'] == 200) {
        this.matDialogRef.close();
        this._contactService.openSnackBar(res['message'], 'mat-primary');
      }
      else {
        this._contactService.openSnackBar(res['message'], 'mat-warn');
      }
    })
  }
  closeDialog() {
    this.deleteDialog.close()
  }
}
